import { useMutation } from "react-query";
import { fetchTrackingRecordSave } from ".";

export const useTrackingRecordSave = () => useMutation(fetchTrackingRecordSave);
